var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"checkout-stepper"},[_c('VuetifyStepper',{attrs:{"items":_vm.stepperItems},on:{"onFinish":_vm.handleFinish}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }